export default {
  SET_NOTIFICATIONS(state, payload) {
    state.notifications = payload
  }
}
